import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPlaylistAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={11}
    fill="currentColor"
    viewBox="0 0 15 11"
    {...props}
  >
    <path
      fill="currentColor"
      d="M.75 7.75a.73.73 0 0 1-.534-.214A.72.72 0 0 1 0 7.004q0-.316.216-.535A.72.72 0 0 1 .75 6.25h4.5q.319 0 .534.214A.72.72 0 0 1 6 6.996q0 .316-.216.535a.72.72 0 0 1-.534.219zm0-3.125a.73.73 0 0 1-.534-.214A.72.72 0 0 1 0 3.879q0-.316.216-.535a.72.72 0 0 1 .534-.219h7.5q.319 0 .534.214A.72.72 0 0 1 9 3.871q0 .316-.216.535a.72.72 0 0 1-.534.219zm0-3.125a.73.73 0 0 1-.534-.214A.72.72 0 0 1 0 .754Q0 .438.216.22A.72.72 0 0 1 .75 0h7.5q.319 0 .534.214A.72.72 0 0 1 9 .746q0 .316-.216.535a.72.72 0 0 1-.534.219zM11.004 11a.73.73 0 0 1-.535-.216.72.72 0 0 1-.219-.534v-2.5h-2.5a.73.73 0 0 1-.534-.214A.72.72 0 0 1 7 7.004q0-.316.216-.535a.72.72 0 0 1 .534-.219h2.5v-2.5q0-.318.214-.534A.72.72 0 0 1 10.996 3q.316 0 .535.216a.72.72 0 0 1 .219.534v2.5h2.5q.319 0 .534.214a.72.72 0 0 1 .216.532q0 .316-.216.535a.72.72 0 0 1-.534.219h-2.5v2.5q0 .319-.214.534a.72.72 0 0 1-.532.216"
    />
  </svg>
);
export default SvgPlaylistAdd;
